var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debug"},[_c('v-header',{attrs:{"title":"Upload Component"}}),_c('div',{staticClass:"wrapper"},[_c('v-upload')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }